<template>
    <section class="ds-page-footer ds-background-color-white">
        <DsDivider theme="light" />
        <div class="ds-container ds-padding-top-48 ds-md-padding-top-96 ds-background-color-white">
            <div class="ds-grid ds-margin-bottom-48 ds-md-margin-bottom-96" :class="{'ds-align-items-center': !$slots.primaryNavigation }">
                <div
                    v-if="!!$slots.primaryNavigation"
                    class="ds-grid__col ds-grid__col--12 ds-md-grid__col--8">
                    <slot name="primaryNavigation"></slot>
                </div>
                <div
                    v-if="!!$slots.socialBar"
                    class="ds-page-footer__social-bar ds-grid__col ds-grid__col--12 ds-md-grid__col--4">
                    <slot name="socialBar"></slot>
                </div>
            </div>
            <div class="ds-page-footer__bottom">
                <slot name="secondaryNavigation"></slot>
                <div v-if="!!$slots.localeSwitcher" class="ds-margin-bottom-24 ds-md-margin-bottom-0">
                    <slot name="localeSwitcher"></slot>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

/**
 * Page footer clicked event
 * @event link-clicked
 * @type {Object}
 * @property {String} url - link url
 * @property {String} label - link text
 * @property {String} type - link type
 */

/**
 * Page footer component
 *
 *  @see [Accessibility] (https://www.w3.org/TR/2021/NOTE-wai-aria-practices-1.2-20211129/examples/menubar/menubar-navigation.html)
 *
 * Usage
 *
 * @example
 * ```js
 * import { DsPageFooter } from '@/layout'
 *
 * export default {
 *   components: { DsPageFooter },
 *   template: `<div>
 *     <DsPageFooter>
 *       <template #primaryNavigation>
 *         ...
 *       </template>
 *       <template #socialBar>
 *         ...
 *       </template>
 *       <template #localeSwitcher>
 *         ...
 *       </template>
 *       <template #secondaryNavigation>
 *         ...
 *       </template>
 *     </DsPageFooter>
 *  `</div>
 *  ```
 * }
 */

import { DsDivider } from '../../atoms';

export default {
    name: 'DsPageFooter',
    components: { DsDivider }
};
</script>

<style lang="scss" scoped>
@import '../../foundation/tokens/variables';
@import '../../foundation/mixins/mixins';

.ds-page-footer {
    &__bottom {
        display: flex;
        flex-direction: column-reverse;
        padding: $spacing-24 $spacing-0;

        @include screen('medium') {
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    &__social-bar {
        display: flex;
        justify-content: flex-start;
        margin-top: $spacing-48;

        @include screen('medium') {
            justify-content: flex-end;
            margin-top: 0;
        }
    }
}
</style>
